import { render, staticRenderFns } from "./ActionHeadlineMessage.vue?vue&type=template&id=552a48ba&scoped=true"
import script from "./ActionHeadlineMessage.vue?vue&type=script&lang=js"
export * from "./ActionHeadlineMessage.vue?vue&type=script&lang=js"
import style0 from "./ActionHeadlineMessage.vue?vue&type=style&index=0&id=552a48ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a48ba",
  null
  
)

export default component.exports